// import React from "react";
// import {
//   FaArrowLeft,
//   FaUser,
//   FaFileAlt,
//   FaQuestionCircle,
//   FaSignOutAlt,
//   FaEnvelope,
//   FaPhone
// } from "react-icons/fa";

// const Profile = () => {
//   return (
//     <div style={page}>
//       {/* Card / Modal */}
//       <div style={card}>
        
//         {/* Header */}
//         <div style={header}>
//           <FaArrowLeft style={{ cursor: "pointer" }} />
//           <h2 style={{ margin: 0 }}>Profile</h2>
//         </div>

//         {/* Profile Info */}
//         <div style={profileCard}>
//           <div style={avatar}>I</div>

//           <h3 style={{ margin: "10px 0 4px" }}>INverstion</h3>
//           <span style={role}>investor</span>

//           <div style={infoRow}>
//             <FaEnvelope />
//             <span>investor@gmail.com</span>
//           </div>

//           <div style={infoRow}>
//             <FaPhone />
//             <span>8475958612</span>
//           </div>
//         </div>

//         {/* Menu */}
//         <div style={menuCard}>
//           <MenuItem icon={<FaUser />} label="Edit Profile" />
//           <MenuItem icon={<FaFileAlt />} label="My Documents" />
//           <MenuItem icon={<FaQuestionCircle />} label="Help & Support" />
//         </div>

//         {/* Logout */}
//         <button style={logoutBtn}>
//           <FaSignOutAlt /> Logout
//         </button>
//       </div>
//     </div>
//   );
// };

// const MenuItem = ({ icon, label }) => (
//   <div style={menuItem}>
//     <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
//       {icon}
//       <span>{label}</span>
//     </div>
//     <span style={{ fontSize: 18 }}>›</span>
//   </div>
// );

// export default Profile;
// const page = {
//   minHeight: "100vh",
//   background: "#f6f7fb",
//   display: "flex",
//   alignItems: "center",
//   justifyContent: "center"
// };

// const card = {
//   width: 420,
//   background: "#fff",
//   borderRadius: 18,
//   padding: 20,
//   boxShadow: "0 20px 40px rgba(0,0,0,0.15)"
// };

// const header = {
//   display: "flex",
//   alignItems: "center",
//   gap: 12,
//   marginBottom: 20
// };

// const profileCard = {
//   background: "#fff",
//   borderRadius: 16,
//   padding: 20,
//   textAlign: "center",
//   boxShadow: "0 8px 20px rgba(0,0,0,0.08)"
// };

// const avatar = {
//   width: 80,
//   height: 80,
//   borderRadius: "50%",
//   background: "#8b2f6c",
//   color: "#fff",
//   fontSize: 36,
//   fontWeight: "bold",
//   display: "flex",
//   alignItems: "center",
//   justifyContent: "center",
//   margin: "0 auto 10px"
// };

// const role = {
//   color: "#2f9e7a",
//   fontWeight: 500
// };

// const infoRow = {
//   display: "flex",
//   alignItems: "center",
//   justifyContent: "center",
//   gap: 8,
//   marginTop: 8,
//   color: "#555"
// };

// const menuCard = {
//   marginTop: 20,
//   background: "#fff",
//   borderRadius: 16,
//   overflow: "hidden",
//   boxShadow: "0 8px 20px rgba(0,0,0,0.08)"
// };

// const menuItem = {
//   display: "flex",
//   justifyContent: "space-between",
//   alignItems: "center",
//   padding: "16px 18px",
//   borderBottom: "1px solid #eee",
//   cursor: "pointer"
// };

// const logoutBtn = {
//   marginTop: 24,
//   width: "100%",
//   background: "#8b2f6c",
//   color: "#fff",
//   border: "none",
//   borderRadius: 14,
//   padding: "14px 0",
//   fontSize: 16,
//   fontWeight: "600",
//   cursor: "pointer",
//   display: "flex",
//   alignItems: "center",
//   justifyContent: "center",
//   gap: 10
// };




import React, { useEffect, useState } from "react";
import {
  FaUserEdit,
  FaFileAlt,
  FaQuestionCircle,
  FaSignOutAlt
} from "react-icons/fa";
import Header from "../Header";
import Footer from "../../LandingPage/Footer";
import { useNavigate } from "react-router-dom";

const Profile = () => {
  const [profile, setProfile] = useState(null);


  const navigate = useNavigate();

const handleLogout = () => {
  // Clear storage
  localStorage.clear();
  sessionStorage.clear();

  // Navigate to landing page
  navigate("/mainlandingpage", { replace: true });
};


  useEffect(() => {
    const storedUser = JSON.parse(localStorage.getItem("user"));
    if (!storedUser) return;

    fetch("https://api.propertygalleria.in/master/api/get/users")
      .then(res => res.json())
      .then(data => {
        const matchedUser = data.find(
          u => u.id === storedUser.id && u.role === storedUser.role
        );
        setProfile(matchedUser);
      });
  }, []);

  if (!profile) return <p style={{ padding: 40 }}>Loading...</p>;

  return (
    <>
    <Header />
    <div style={page}>
      <div style={container}>

        {/* LEFT PROFILE CARD */}
        <div style={leftCard}>
          <div style={avatar}>
            {profile.name?.charAt(0).toUpperCase()}
          </div>

          <h2>{profile.full_name}</h2>
          <span style={role}>{profile.role}</span>

          <div style={info}>
            <p>📧 {profile.email}</p>
            <p>📞 {profile.mobile_number}</p>
          </div>
        </div>

        {/* RIGHT ACTIONS */}
        <div style={rightCard}>
          <Action icon={<FaUserEdit />} label="Edit Profile" />
          <Action icon={<FaFileAlt />} label="My Documents" />
          <Action icon={<FaQuestionCircle />} label="Help & Support" />

          <button style={logoutBtn} onClick={handleLogout}>
            <FaSignOutAlt /> Logout
          </button>
        </div>

      </div>
    </div>

     <Footer/>
    </>
  );
};

const Action = ({ icon, label }) => (
  <div style={actionRow}>
    <div style={{ display: "flex", gap: 12, alignItems: "center" }}>
      {icon}
      <span>{label}</span>
    </div>
    <span>›</span>
  </div>
);

export default Profile;

const page = {
  minHeight: "100vh",
  background: "#f4f6fb",
  padding: 40,
  paddingTop: '100px',
};

const container = {
  maxWidth: 1100,
  margin: "0 auto",
  display: "grid",
  gridTemplateColumns: "1fr 2fr",
  gap: 30
};

const leftCard = {
  background: "#fff",
  borderRadius: 16,
  padding: 30,
  boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
  textAlign: "center"
};

const avatar = {
  width: 120,
  height: 120,
  borderRadius: "50%",
  background: "#8b2f6c",
  color: "#fff",
  fontSize: 48,
  fontWeight: "bold",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  margin: "0 auto 15px"
};

const role = {
  color: "#2f9e7a",
  fontWeight: 600
};

const info = {
  marginTop: 20,
  color: "#555"
};

const rightCard = {
  background: "#fff",
  borderRadius: 16,
  padding: 30,
  boxShadow: "0 10px 30px rgba(0,0,0,0.08)"
};

const actionRow = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  padding: "18px 0",
  borderBottom: "1px solid #eee",
  cursor: "pointer",
  fontSize: 16
};

const logoutBtn = {
  marginTop: 30,
  width: "100%",
  background: "#8b2f6c",
  color: "#fff",
  border: "none",
  padding: 14,
  borderRadius: 12,
  fontSize: 16,
  cursor: "pointer",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  gap: 10
};

